import React from "react";
import UserField from "../misc/UserField";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";

class FilterAssigneeModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
  }

  getInitialState() {
    return {
      assignee: null,
      assigneeName: ""
    };
  }

  onChange(e, data) {
    let assigneeName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function(item) {
        if (item.value === data.value) {
          assigneeName = item.text;
        }
      });

      this.setState({
        assignee: data.value,
        assigneeName
      });
    }
  }

  saveAndExit() {
    this.props.filterAssignee(null, {
      value: this.state.assignee,
      label: this.state.assigneeName
    });
    this.props.chooseAssignee(false);
  }

  render() {
    let self = this;

    return (
      <Modal
        open={true}
        onClose={() => {
          this.props.chooseAssignee(false);
        }}
        closeIcon
      >
        <Header icon="pin" content="Filter By Assignee..." />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <UserField
                  label="Assigned User"
                  userData={null}
                  selectedUser={this.state.assignee}
                  onChange={(e, data) => self.onChange(e, data)}
                  onReset={self.onReset}
                />
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="filter" /> Filter
          </Button>
          <Button
            color="grey"
            onClick={() => {
              this.props.chooseAssignee(false);
            }}
          >
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(FilterAssigneeModal);



// WEBPACK FOOTER //
// ./src/components/modals/FilterAssigneeModal.js